/**
 * Recently viewed — OPTIONAL (not locked). The shopper's own browse-history row
 * on the PDP (localStorage, excludes the current product). Removable + addable
 * from the editor, exactly like `product-policies`: a store that doesn't want it
 * removes it, and adds it back from the Add-section flow. Not `criticalForSeo`
 * (peripheral, buyer-local content). Lives under `templates.product` only.
 */
export const productRecentlyViewedSchema = {
    type: "product-recently-viewed",
    name: { ar: "شوهدت مؤخرًا", en: "Recently viewed" },
    description: {
        ar: 'قسم "شوهدت مؤخرًا" أسفل صفحة المنتج (سجل تصفح الزائر).',
        en: "The shopper's recently-viewed products row shown on the product page.",
    },
    locked: false,
    maxPerTemplate: 1,
    availableOnTemplates: ["product"],
    settings: [
        {
            id: "showRecentlyViewed",
            type: "checkbox",
            label: { ar: 'إظهار قسم "شوهدت مؤخرًا"', en: 'Show "Recently viewed"' },
            default: true,
        },
    ],
};
//# sourceMappingURL=product-recently-viewed.js.map